import { render, staticRenderFns } from "./conversation-composer.vue?vue&type=template&id=49c8d8c7&scoped=true"
import script from "./conversation-composer.vue?vue&type=script&lang=js"
export * from "./conversation-composer.vue?vue&type=script&lang=js"
import style0 from "./conversation-composer.vue?vue&type=style&index=0&id=49c8d8c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c8d8c7",
  null
  
)

export default component.exports